import React, { useState } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { TextField } from '@mui/material';
import { Link, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as auth from '../../store/ducks/auth.duck';
import { requestPassword } from '../../crud/auth.crud';

function ForgotPassword () {
    const { t } = useTranslation();
    const [isRequested, setIsRequested] = useState(false);

    if (isRequested) {
        return <Redirect to="/auth" />;
    }

    return (
        <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
            <div className="kt-login__body">
                <div className="kt-login__form">
                    <div className="kt-login__title">
                        <h3>
                            {t('login.forgot.title')}
                        </h3>
                    </div>

                    <Formik
                        initialValues={{ email: '' }}
                        validate={values => {
                            const errors = {};

                            if (!values.email) {
                                errors.email = t('validation.requiredField');
                            }
                            else if (
                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                            ) {
                                errors.email = t('validation.invalidField');
                            }

                            return errors;
                        }}
                        onSubmit={(values, { setStatus, setSubmitting }) => {
                            requestPassword(values.email)
                                .then(() => {
                                    setIsRequested(true);
                                })
                                .catch(() => {
                                    setSubmitting(false);
                                    setStatus(
                                        t('validation.notFound')
                                    );
                                });
                        }}
                    >
                        {({
                            values,
                            status,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting
                        }) => (
                            <form onSubmit={handleSubmit} className="kt-form">
                                {status && (
                                    <div role="alert" className="alert alert-danger">
                                        <div className="alert-text">{status}</div>
                                    </div>
                                )}

                                <div className="form-group">
                                    <TextField
                                        type="email"
                                        label="Email"
                                        margin="normal"
                                        fullWidth={true}
                                        name="email"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.email}
                                        helperText={touched.email && errors.email}
                                        error={Boolean(touched.email && errors.email)}
                                    />
                                </div>

                                <div className="kt-login__actions">
                                    <Link to="/auth">
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-elevate kt-login__btn-secondary"
                                        >
                                            Back
                                        </button>
                                    </Link>

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-elevate kt-login__btn-primary"
                                        disabled={isSubmitting}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
}

export default connect(null, auth.actions)(ForgotPassword);
